import { PostedPaymentInfo } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

export const useFetchPostedPayments = () => {
  const fetchPostedPayments = async () => {
    const res = await medicareApiClient.premiumsApi.getPremiumsPostedPayments()
    return res.data
  }

  return useQuery<PostedPaymentInfo[] | undefined>(
    'PostedPayments',
    fetchPostedPayments,
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  )
}
